import React from 'react';
import { Badge, styled } from "@mui/material";
import Avatar from "../../../../components/Avatar";
import { createAvatarName, hasImage } from "../../../../utils";
import HistoryIcon from "../../../../styles/svg/history-icon.svg";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 16,
  height: 16,
  border: `2px solid ${theme.palette.background.paper}`,
}));

const HistoryAvatar = ({ showIcon, userData, size = "32px" }) => {
  const avatarProps = {
    user_image: userData?.user_image,
    title: userData?.username,
    style: {
      height: size,
      width: size,
      ...(!hasImage(userData?.user_image) && {
        bgcolor: userData?.profile_color?.background,
        color: userData?.profile_color?.text,
      }),
    },
    className: "header-avatar",
    children: createAvatarName(userData?.username || ""),
  };

  if (showIcon) {
    return (
      <Badge
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        badgeContent={<SmallAvatar alt="History Icon" src={HistoryIcon} />}
      >
        <Avatar {...avatarProps} />
      </Badge>
    );
  }

  return <Avatar {...avatarProps} />;
};

export default HistoryAvatar; 